import { CLIENT_TYPES } from '@/modules/clients/constants/client.constants';
import { getCanonicalClientContacts } from '../utils/clientContacts.helpers';

export function getInitialEditClientDialogModel(client) {
  if (!client) return null;

  return {
    ...client,
    tipoCliente: client.tipoCliente || CLIENT_TYPES.CEDENTE,
    ...getCanonicalClientContacts(client),
  };
}

export function validateEditClientModel(model) {
  if (
    !model?.name ||
    !model?.company ||
    !model?.tipoCliente ||
    !model?.businessName ||
    !model?.vatNumber ||
    !model?.codiceFiscale
  ) {
    return 'Compila tutti i campi obbligatori';
  }

  return null;
}
